import React from 'react';
import Modal from 'react-bootstrap/Modal';

import { ModalClose } from '../../../common/components';

type ContractSubmittedProps = {
  onHide: Function;
  show: boolean;
  title: string;
  messagevalues: Messages.IMessagesValues;
};

const defaultProps = {
  onHide: undefined,
  show: false,
  title: 'Contracts submitted',
  messagevalues: {},
};

export const ContractSubmitted = (props: ContractSubmittedProps) => {
  return (
    <>
      <span className='font-medium'>
        {props.messagevalues.date}
        <span className='ml-2'>{props.messagevalues.time}</span>
      </span>
      <Modal.Header>
        <Modal.Title>{props.messagevalues.title}</Modal.Title>
        <ModalClose onClick={() => props.onHide()} />
      </Modal.Header>
      <Modal.Body>
        <p>{props.messagevalues.subject}</p>
      </Modal.Body>
      <Modal.Footer className='hidden'></Modal.Footer>
    </>
  );
};

ContractSubmitted.defaultProps = defaultProps;
